import React, { useState } from 'react';
import { Navbar, Container, Nav, Button, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Header.css';
import { renderTextWithNormalDash } from '../../utils/textFormatters';

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showServices, setShowServices] = useState(false);
  let hideTimeout = null;

  const handleMouseEnter = () => {
    if (hideTimeout) clearTimeout(hideTimeout);
    setShowServices(true);
  };

  const handleMouseLeave = () => {
    hideTimeout = setTimeout(() => {
      setShowServices(false);
    }, 250); // delay in ms
  };
  return (
    <header className="eo-header">
      {/* Top bar */}
      <Navbar className="eo-topbar" expand="lg" variant="dark">
        <Container>
          <Navbar.Brand
            as={Link}
            to="/"
            className="eo-brand d-inline-flex align-items-center text-decoration-none"
          >
            <img src="/elite-optix-logo.png" alt="Elite Optix Logo" />
          </Navbar.Brand>

          <div className=" d-flex align-items-center text-white eo-utilities py-2">
            {/* Hamburger (mobile only) */}
            <button
              className="eo-icon-btn eo-hamburger"
              aria-label="Open menu"
              onClick={() => setMobileOpen(true)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/icons/menu.png`}
                alt="Menu"
                className="eo-icon"
              />
            </button>
            {/* <Navbar className="eo-mainnav" variant="dark">
              <Container>
                <Nav className="eo-menu">
                  <Nav.Link as={Link} to="/about">ABOUT</Nav.Link>
                  <Nav.Link as={Link} to="/services">SERVICES</Nav.Link>
                  <Nav.Link as={Link} to="/insights">INSIGHTS</Nav.Link>
                  <Nav.Link as={Link} to="/contact">CONTACT</Nav.Link>
                </Nav>
                <Button as={Link} to="/contact" className="eo-cta">
                  MAKE AN APPOINTMENT
                </Button>
              </Container>
            </Navbar> */}
            {/* Desktop Navigation */}

            <Navbar className="eo-menu" variant="dark">
              <Container className="d-flex flex-column align-items-end justify-content-between h-100">

                <Nav className="eo-menu gap-4">
                  <Nav.Link as={Link} to="/">HOME</Nav.Link>
                  <Nav.Link as={Link} to="/about">ABOUT</Nav.Link>

                  {/* Services Dropdown (opens on hover) */}
                  <NavDropdown
                    id="services-dropdown"
                    show={showServices}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    menuVariant='dark'
                    key="service-button"
                    title={
                      <Link
                        key="service-button link"
                        to="/services"
                        className="nav-link  text-white text-decoration-none"
                        onClick={(e) => e.stopPropagation()} // prevent accidental dropdown close
                      >
                        SERVICES
                      </Link>
                    }
                  >
                    <NavDropdown.Item as={Link} to="/services/sunglasses" className="py-2">
                      SUNGLASSES
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/services/eye-exam" className="py-2">
                      EYE EXAM
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/services/safety-glasses" className="py-2">
                      SAFETY GLASSES
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/services/eye-glasses" className="py-2">
                      EYE GLASSES
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/services/sports-goggles" className="py-2">
                      SPORTS GOGGLES
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/services/contact-lenses" className="py-2">
                      CONTACT LENSES
                    </NavDropdown.Item>
                  </NavDropdown>
                  <Nav.Link as={Link} to="/insights">INSIGHTS</Nav.Link>
                  <Nav.Link as={Link} to="/contact">CONTACT</Nav.Link>
                </Nav>
              </Container>
            </Navbar>
          </div>
          <div className='eo-cta-section d-flex gap-1 '>
            <Button as={Link} to="/contact" className="eo-cta">
              MAKE AN APPOINTMENT
            </Button>
            <Button as={Link} to="tel:4167462626" className="eo-cta">
              {renderTextWithNormalDash("(416)-746-2626")}
            </Button>
          </div>
        </Container>
      </Navbar>

      {/* Mobile nav overlay */}
      <div className={`eo-mobile-nav ${mobileOpen ? 'open' : ''}`}>
        <button className="eo-close-btn" onClick={() => setMobileOpen(false)}>
          ✕
        </button>

        <nav className="eo-mobile-menu">
          <Link to="/" onClick={() => setMobileOpen(false)}>HOME</Link>
          <Link to="/about" onClick={() => setMobileOpen(false)}>ABOUT</Link>

          <NavDropdown
            id="services-dropdown"
            show={showServices}
            onMouseEnter={() => setShowServices(true)}
            onMouseLeave={() => setShowServices(false)}
            menuVariant='dark'
            key="service-button"
            title={
              <Link
                key="service-button link"
                to="/services"
                className="nav-link  text-white text-decoration-none"
                onClick={(e) => e.stopPropagation()} // prevent accidental dropdown close
              >
                SERVICES
              </Link>
            }
          >
            <NavDropdown.Item as={Link} to="/services/sunglasses" className="py-2 small" onClick={() => setMobileOpen(false)}>
              Sunglasses
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/services/eye-exam" className="py-2 small" onClick={() => setMobileOpen(false)}>
              Eye Exam
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/services/safety-glasses" className="py-2 small" onClick={() => setMobileOpen(false)}>
              Safety Glasses
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/services/eye-glasses" className="py-2 small" onClick={() => setMobileOpen(false)}>
              Eye Glasses
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/services/sports-goggles" className="py-2 small" onClick={() => setMobileOpen(false)}>
              Sports Goggles
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/services/contact-lenses" className="py-2 small" onClick={() => setMobileOpen(false)}>
              Contact Lenses
            </NavDropdown.Item>
          </NavDropdown>


          <Link to="/insights" onClick={() => setMobileOpen(false)}>INSIGHTS</Link>
          <Link to="/contact" onClick={() => setMobileOpen(false)}>CONTACT</Link>
          <Link to="/contact" className="eo-mobile-cta" onClick={() => setMobileOpen(false)}>
            MAKE AN APPOINTMENT
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
